import { AUTH_PATHS } from '../../client/authPaths';

/**
 * URL builders for the auth endpoints. Sourced from the same `AUTH_PATHS`
 * constants the interceptors match on, so the credential the request layer
 * attaches can never drift from the path the service actually calls.
 */
export const AuthEndpoints = {
    deviceExchange: () => AUTH_PATHS.DEVICE_EXCHANGE,
    deviceUsers: () => AUTH_PATHS.DEVICE_USERS,
    pin: () => AUTH_PATHS.PIN,
    pinVerify: () => AUTH_PATHS.PIN_VERIFY,
    logout: () => AUTH_PATHS.LOGOUT,
};
